import HelpTip from '@components/officialSupport/workTemp/HelpTip.vue';
import { mapState } from 'vuex';
export default {
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String,
      default: ''
    },
    labelInfo: {
      type: Object,
      default: () => ({
        label: '',
        tip: '',
        required: false,
        tipImg: []
      })
    },
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.languages
    })
  },
  components: {
    HelpTip
  }
};
